import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <section className="about">
      <div className="textbox">
        <h2 className="about-heading">About Us</h2>
      </div>
      <div className="textbox">
        <p>
          Temple Gardening bring deep expertise to the art of cultivating serene outdoor spaces. Using minimalist principles that we learned while gardening for actual temples, we design gardens with clarity and intention. With a gentle love of nature and years of refined knowledge, we will transform your garden into a tranquil retreat.
        </p>
      </div>
    </section>
  );
};

export default About;